import type { ColumnFilterConfig } from "../../columnFilter/types";

const AUTO_COLUMN_ID = "ag-Grid-AutoColumn";

/** The subset of ag-Grid's floating filter params the filter cell reads; kept structural so no ag-grid import is needed. */
export interface FloatingFilterParamsLike {
  column?: { getColId?: () => string };
  filterConfig?: ColumnFilterConfig | null;
  filterColKey?: unknown;
  originalHiddenColId?: unknown;
}

export function resolveFilterColumnKey(params: FloatingFilterParamsLike): string {
  const colId = params.column?.getColId?.() ?? "";

  if (typeof params.filterColKey === "string" && params.filterColKey) return params.filterColKey;

  if (colId === AUTO_COLUMN_ID && typeof params.originalHiddenColId === "string" && params.originalHiddenColId) {
    return params.originalHiddenColId;
  }

  return colId;
}

export function toColumnFilterConfig(params: FloatingFilterParamsLike): ColumnFilterConfig | null {
  return params.filterConfig ?? null;
}
